const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function requestNotificationPermission() {
  if (!('Notification' in window)) {
    return { granted: false, reason: 'not-supported' };
  }
  
  if (Notification.permission === 'granted') {
    return { granted: true };
  }
  
  if (Notification.permission === 'denied') {
    return { granted: false, reason: 'denied' };
  }
  
  const permission = await Notification.requestPermission();
  return { granted: permission === 'granted', reason: permission };
}

export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return null;
  
  try {
    const registration = await navigator.serviceWorker.register('/sw.js');
    return registration;
  } catch (err) {
    console.warn('SW registration failed:', err);
    return null;
  }
}

export async function registerPushToken(token) {
  try {
    const headers = {};
    const authToken = localStorage.getItem('token');
    if (authToken) headers['Authorization'] = `Bearer ${authToken}`;
    
    await fetch(`${API}/push/register`, {
      method: 'POST',
      headers: { ...headers, 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ token, platform: 'web' })
    });
    return true;
  } catch (err) {
    console.warn('Push token registration failed:', err);
    return false;
  }
}

export async function initPushNotifications() {
  const { granted } = await requestNotificationPermission();
  if (!granted) return false;
  
  const registration = await registerServiceWorker();
  if (!registration) return false;
  
  // For web push without FCM, we use a simple token approach
  const token = `web_${Date.now()}_${Math.random().toString(36).slice(2)}`;
  localStorage.setItem('push_token', token);
  
  await registerPushToken(token);
  return true;
}

export function showLocalNotification(title, body, url = '/') {
  if (Notification.permission !== 'granted') return;
  
  const notification = new Notification(title, {
    body,
    icon: '/favicon.ico',
    tag: 'gas-station-local',
  });
  
  notification.onclick = () => {
    window.focus();
    if (url !== '/') window.location.href = url;
    notification.close();
  };
}
